import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    withStyles,
} from '@material-ui/core'
import React from 'react'
import { connect } from 'react-redux'
import { getProductAssetsForProduct } from '../actions/UploadActions'

const styles = theme => ({})

class ProductAssets extends React.Component {
    componentDidMount() {
        if (this.props.sku) {
            this.props.getProductAssets(this.props.sku)
        }
    }

    render() {
        const rows = Object.values(this.props.assets).map(
            ({ id, url, assetType, models, skus, brand, label }) => {
                return (
                    <TableRow key={id}>
                        <TableCell>
                            <a href={url}>{label}</a>
                        </TableCell>
                        <TableCell>{assetType.name}</TableCell>
                        <TableCell>{skus.join(', ')}</TableCell>
                        <TableCell>{models.join(', ')}</TableCell>
                        <TableCell>{brand}</TableCell>
                    </TableRow>
                )
            }
        )

        return (
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Url</TableCell>
                        <TableCell>Typ</TableCell>
                        <TableCell>Sku</TableCell>
                        <TableCell>Model</TableCell>
                        <TableCell>Marka</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>{rows}</TableBody>
            </Table>
        )
    }
}

const mapStateToProps = ({ presto }) => {
    return {
        assets: presto.productAssets.items,
    }
}

export default connect(mapStateToProps, {
    getProductAssets: getProductAssetsForProduct,
})(withStyles(styles, { withTheme: true })(ProductAssets))
